<template>
  <page>
    <template slot="title">Новости</template>
    <template slot="section">
      <div class="news">
        <a v-for="(news, index) in allNews" :key="index" :href="news.url">
          <p>{{ news.preview }}</p>
          <span>{{ news.date }}</span>
        </a>
      </div>
    </template>
    <template slot="aside">
      <aside-image :image="imageBg"/>
    </template>
  </page>
</template>

<script>
import imageBg from '../../static/i/img-15.jpg';

import Page from '@/components/Page';
import AsideImage from '@/components/AsideImage';

export default {
  components: {
    Page,
    AsideImage,
  },
  data: () => {
    return {
      imageBg: imageBg,
      allNews: null,
    }
  },
  mounted() {
    /*axios
      .get('../data/news.json')
      .then(response => {
        this.allNews = response.data;
      })*/
    this.allNews = require('@/data/news.json');
  }
}
</script>

<style lang="scss">
.news {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  a {
    text-decoration: none;
    border: 2px solid #dedede;
    border-radius: 10px;
    padding: 10px 13px;
    width: 32%;
    margin: 0 0 2%;
    transition: all .3s ease;
    &:hover {
      box-shadow: inset 0 0 0 150px #efefef;
    }
    @media (max-width: 767px) {
      width: 100%;
    }
  }
  p {
    font-weight: 300;
  }
  span {
    font-weight: 500;
    display: block;
    text-align: right;
    font-size: 24px;
    @media (max-width: 767px) {
      font-size: 18px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// News.vue?ca679a4e